import "./commodities-header.css";

import { ColumnChooser } from "~/shared/components/column-chooser/column-chooser.tsx";
import { CustomerSearch } from "~/shared/components/customer-search/customer-search.tsx";
import type { BoardColumn } from "~/shared/types/quote-board-types.ts";
import type { Customer } from "~/shared/types/quote-details-types";

type CommoditiesHeaderProps = {
	selectedCustomer: Customer | undefined;
	onCustomerChange: (customer: Customer | null) => void;
	columns: BoardColumn[];
	onColumnToggle: (column: BoardColumn) => void;
	onResetColumns?: () => void;
	isMobile?: boolean;
};

export const CommoditiesHeader = ({
	selectedCustomer,
	onCustomerChange,
	columns,
	onColumnToggle,
	onResetColumns,
	isMobile = false,
}: CommoditiesHeaderProps) => {
	return (
		<div
			className={`commodities-header ${isMobile ? "commodities-header-mobile" : ""}`}
		>
			<CustomerSearch
				onCustomerChange={onCustomerChange}
				selectedCustomer={selectedCustomer}
				wrapperStyle={{ width: isMobile ? "100%" : "300px" }}
			/>

			{!!selectedCustomer && !isMobile && (
				<ColumnChooser
					secondary
					className={"commodities-column-chooser"}
					columns={columns}
					onColumnToggle={onColumnToggle}
					onResetColumns={onResetColumns}
				/>
			)}
		</div>
	);
};
